import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["gradeInput"]
  static values = { 
    itemId: String,
    extrapolateUrl: String,
    successMessage: String,
  }

  connect() {
    console.log("Grade extrapolation controller connected")
  }

  async extrapolate(event) {
    const inputElement = event.currentTarget
    if (inputElement.value === "") {
      return
    }

    // Debounce to avoid too many requests
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    this.timeout = setTimeout(async () => {
      await this.performExtrapolation()
    }, 300)
  }

  async performExtrapolation() {
    try {
      this.showLoadingState()
      
      // Build URL with query parameters
      const url = new URL(this.extrapolateUrlValue, window.location.origin)
      const gradeValues = this.collectGradeValues()
      const year = this.getYearValue()
      
      // Add grade values as query parameters
      Object.entries(gradeValues).forEach(([gradeNumber, value]) => {
        if (value !== null) {
          url.searchParams.append(`grade_values[${gradeNumber}]`, value)
        }
      })
      
      // Add year parameter
      if (year !== null) {
        url.searchParams.append('year', year)
      }
      
      // Make AJAX request to extrapolate values
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const extrapolatedValues = await response.json()
      this.updateGradeFields(extrapolatedValues)

    } catch (error) {
      console.error('Error during extrapolation:', error)
      this.showErrorState()
    } finally {
      this.hideLoadingState()
    }
  }

  updateGradeFields(extrapolatedValues) {
    const self = this;

    let updated = false;
    Object.entries(extrapolatedValues).forEach(([gradeNumber, value]) => {
      const input = self.element.querySelector(`input[name="item[${gradeNumber}]"]`)
      if (input && value !== null) {
        if (!input.value || input.value.trim() === '') {
          input.value = parseFloat(value).toFixed(2)
          // Trigger change event to update any other listeners
          input.dispatchEvent(new Event('change', { bubbles: true }))
          updated = true;
        }
      }
    })
    if (updated) {
      showToast(this.successMessageValue, 'alert alert-success');
    }
  }

  collectGradeValues() {
    const values = {}
    const gradeInputs = this.element.querySelectorAll('input[name*="value"]')
    
    gradeInputs.forEach(input => {
      const name = input.name
      const match = name.match(/value(\d+)/)
      if (match) {
        const gradeNumber = match[1]
        const value = parseFloat(input.value) || ""
        values[gradeNumber] = value
      }
    })
    
    return values
  }

  getYearValue() {
    const form = this.element.closest('form')
    const yearInput = form ? form.querySelector('input[name="item[year]"]') : null
    return yearInput && yearInput.value ? parseInt(yearInput.value) : null
  }

  showLoadingState() {
    // TODO: Implement loading state
  }

  hideLoadingState() {
    // TODO: Hide loading state
  }

  showErrorState() {
    // TODO: Show error
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }
}
